var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["ENQUEUE"] = 0] = "ENQUEUE";
    ACTIONS[ACTIONS["RESET_STATE"] = 1] = "RESET_STATE";
})(ACTIONS || (ACTIONS = {}));
var QUEUE_LENGTH = 10;
var initRegionQueue = [];
for (var i = 0; i < QUEUE_LENGTH; i += 1)
    initRegionQueue.push({ announcementIndex: -1, announcement: '' });
export var initialRegionState = {
    nextRegionIndex: 0,
    nextAnnouncementIndex: 0,
    queue: initRegionQueue,
};
var nextRegionIndex = function (currentRegionIndex) {
    return currentRegionIndex === QUEUE_LENGTH - 1 ? 0 : currentRegionIndex + 1;
};
export var regionReducer = function (state, action) {
    var currentRegionIndex = state.nextRegionIndex;
    var currentAnnouncementIndex = state.nextAnnouncementIndex;
    var clone = __spreadArrays(state.queue);
    switch (action.type) {
        case ACTIONS.RESET_STATE:
            return initialRegionState;
        case ACTIONS.ENQUEUE:
            // eslint-disable-next-line security/detect-object-injection
            clone[currentRegionIndex] = __assign(__assign({}, action.payload), { announcementIndex: currentAnnouncementIndex });
            return {
                nextRegionIndex: nextRegionIndex(currentRegionIndex),
                nextAnnouncementIndex: currentAnnouncementIndex + 1,
                queue: clone,
            };
        default:
            return state;
    }
};
//# sourceMappingURL=reducerUtils.js.map